export class SocioModel {
  public idSocio: number;
  public idUsuario: number;
  public codigo: string;
  public dro: string;
  public cda: string;
  public apellidoPat: string;
  public apellidoMat: string;
  public nombreCompleto: string;
  public nickName: string;
  public curriculumVitae: string;
  public genero: string;
  public calle: string;
  public numero: string;
  public codigoPostal: string;
  public idCiudad: number;
  public ciudad: string;
  public estado: string;
  public colonia: string;
  public correoElectronico: string;
  public telefonoFijo: string;
  public telefonoMovil: string;
  public fechaAlta: string;
  public fechaBaja: number;
  public motivoBaja: string;
  public fechaNacimiento: string;
  public esActivo: boolean;
  public curp: string;
  public nss: string;
  public ife: string;
  public rolUsuario: number;
  public avatarUri: string;
  public requisitos: Requisito[];
  public titulo: string;
  public mostrarCorreo: boolean;
  public mostrarTelefono: boolean;

  constructor() {}
}

export class Requisito {
  public idSocio: number;
  public idRequisito: number;
  public evidencia: string;
}
